import { css } from '@emotion/react'

export const QUICK_REPLY = 'QUICK_REPLY'
export const FLOATING_PREVIEW = 'FLOATING_PREVIEW'
export const FLOATING_ROOM = 'FLOATING_ROOM'
export const MY_WEBCAM = 'MY_WEBCAM'

const landscapeStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-width)',
})
const landscapeExpandedNavStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-expanded-width)',
})
const landscapeExpandedSidebarStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-width)',
})
const landscapeExpandedAllStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-expanded-width)',
})
const landscapeContentStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-width)',
})
const landscapeExpandedNavContentStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-expanded-width)',
})
const landscapeExpandedSidebarContentStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-width)',
})
const landscapeExpandedAllContentStyles = css({
    top: 'var(--header-height)',
    left: 'var(--nav-expanded-width)',
})
const fullWindowStyles = css({
    top: 0,
    left: 0,
})
const portraitStyles = css({
    top: 'var(--header-height)',
    left: 0,
})
const portraitExpandedSidebarStyles = css({
    top: 'var(--header-height)',
    left: 0,
})
const portraitContentStyles = css({
    top: 'var(--header-height)',
    left: 0,
})
const portraitExpandedSidebarContentStyles = css({
    top: 'var(--header-height)',
    left: 0,
})

const landscapeSizeStyles = css({
    width: 'calc(100% - var(--nav-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedNavSizeStyles = css({
    width: 'calc(100% - var(--nav-expanded-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedSidebarSizeStyles = css({
    width: 'calc(100% - var(--nav-sidebar-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedAllSizeStyles = css({
    width: 'calc(100% - var(--nav-expanded-all-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeContentSizeStyles = css({
    width: 'calc(100% - var(--nav-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedNavContentSizeStyles = css({
    width: 'calc(100% - var(--nav-expanded-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedSidebarContentSizeStyles = css({
    width: 'calc(100% - var(--nav-sidebar-width))',
    height: 'calc(100% - var(--header-height))',
})
const landscapeExpandedAllContentSizeStyles = css({
    width: 'calc(100% - var(--nav-expanded-all-width))',
    height: 'calc(100% - var(--header-height))',
})
const fullWindowSizeStyles = css({
    width: '100%',
    height: '100%',
})
const portraitSizeStyles = css({
    width: '100%',
    height: 'calc(100% - var(--portrait-header-nav))',
})
const portraitExpandedSidebarSizeStyles = css({
    width: 'calc(100% - var(--sidebar-width))',
    height: 'calc(100% - var(--portrait-header-nav))',
})
const portraitContentSizeStyles = css({
    width: '100%',
    height: 'calc(100% - var(--portrait-header-nav))',
})

const portraitLandscapeMedianSizeStyles = css({
    width: '100%',
    height: 'calc(100% - var(--portrait-header-bottom-nav))',
})

const portraitExpandedSidebarContentSizeStyles = css({
    width: 'calc(100% - var(--sidebar-width))',
    height: 'calc(100% - var(--portrait-header-nav))',
})

export enum FloaterPageState {
    FULL_WINDOW = 'FULL_WINDOW',
    LANDSCAPE = 'LANDSCAPE',
    LANDSCAPE_EXPANDED_NAV = 'LANDSCAPE_EXPANDED_NAV',
    LANDSCAPE_EXPANDED_SIDEBAR = 'LANDSCAPE_EXPANDED_SIDEBAR',
    LANDSCAPE_EXPANDED_ALL = 'LANDSCAPE_EXPANDED_ALL',
    PORTRAIT = 'PORTRAIT',
    PORTRAIT_LANDSCAPE_MEDIAN = 'PORTRAIT_LANDSCAPE_MEDIAN',
    PORTRAIT_EXPANDED_SIDEBAR = 'PORTRAIT_EXPANDED_SIDEBAR',
    LANDSCAPE_CONTENT = 'LANDSCAPE_CONTENT',
    LANDSCAPE_EXPANDED_NAV_CONTENT = 'LANDSCAPE_EXPANDED_NAV_CONTENT',
    LANDSCAPE_EXPANDED_SIDEBAR_CONTENT = 'LANDSCAPE_EXPANDED_SIDEBAR_CONTENT',
    LANDSCAPE_EXPANDED_ALL_CONTENT = 'LANDSCAPE_EXPANDED_ALL_CONTENT',
    PORTRAIT_CONTENT = 'PORTRAIT_CONTENT',
    PORTRAIT_EXPANDED_SIDEBAR_CONTENT = 'PORTRAIT_EXPANDED_SIDEBAR_CONTENT',
}

export const FULLPAGE_LOCATION_STYLE_MAP = {
    [FloaterPageState.FULL_WINDOW]: fullWindowStyles,

    [FloaterPageState.LANDSCAPE]: landscapeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV]: landscapeExpandedNavStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR]:
        landscapeExpandedSidebarStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL]: landscapeExpandedAllStyles,
    [FloaterPageState.PORTRAIT]: portraitStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR]: portraitExpandedSidebarStyles,
    [FloaterPageState.PORTRAIT_LANDSCAPE_MEDIAN]: portraitStyles,

    [FloaterPageState.LANDSCAPE_CONTENT]: landscapeContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV_CONTENT]:
        landscapeExpandedNavContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR_CONTENT]:
        landscapeExpandedSidebarContentStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL_CONTENT]:
        landscapeExpandedAllContentStyles,
    [FloaterPageState.PORTRAIT_CONTENT]: portraitContentStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR_CONTENT]:
        portraitExpandedSidebarContentStyles,
}
export const FULLPAGE_SIZE_STYLE_MAP = {
    [FloaterPageState.FULL_WINDOW]: fullWindowSizeStyles,

    [FloaterPageState.LANDSCAPE]: landscapeSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV]: landscapeExpandedNavSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR]:
        landscapeExpandedSidebarSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL]: landscapeExpandedAllSizeStyles,
    [FloaterPageState.PORTRAIT]: portraitSizeStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR]:
        portraitExpandedSidebarSizeStyles,
    [FloaterPageState.PORTRAIT_LANDSCAPE_MEDIAN]:
        portraitLandscapeMedianSizeStyles,

    [FloaterPageState.LANDSCAPE_CONTENT]: landscapeContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_NAV_CONTENT]:
        landscapeExpandedNavContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_SIDEBAR_CONTENT]:
        landscapeExpandedSidebarContentSizeStyles,
    [FloaterPageState.LANDSCAPE_EXPANDED_ALL_CONTENT]:
        landscapeExpandedAllContentSizeStyles,
    [FloaterPageState.PORTRAIT_CONTENT]: portraitContentSizeStyles,
    [FloaterPageState.PORTRAIT_EXPANDED_SIDEBAR_CONTENT]:
        portraitExpandedSidebarContentSizeStyles,
}

export enum FloaterSize {
    Small,
    Medium,
    Large,
    Fullscreen,
}
